var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageHash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 32.5C6.5 33.6493 6.95655 34.7515 7.7692 35.5641C8.58186 36.3768 9.68406 36.8333 10.8333 36.8333H36.8333L45.5 45.5V10.8333C45.5 9.68406 45.0435 8.58186 44.2308 7.7692C43.4181 6.95655 42.3159 6.5 41.1667 6.5H10.8333C9.68406 6.5 8.58186 6.95655 7.7692 7.7692C6.95655 8.58186 6.5 9.68406 6.5 10.8333V32.5Z",
    stroke: "#2B2F51",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3335 19.5H32.6668",
    stroke: "#2B2F51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3335 24.5H32.6668",
    stroke: "#2B2F51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3332 14.5L22.6665 29.5",
    stroke: "#2B2F51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3332 14.5L27.6665 29.5",
    stroke: "#2B2F51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageHash);
export default __webpack_public_path__ + "static/media/message-hash.5de56163e24025d31ae5e0b120ca7728.svg";
export { ForwardRef as ReactComponent };